const state = {
   progress:{},
}

export default state
